module.exports = __webpack_public_path__ + "static/media/Message.66dc3ab2.svg";